import { useTranslation } from 'react-i18next'

interface AccessTierOption {
  value: string
  label: string
}

interface FeatureOption {
  value: string
  label: string
  description: string
}

export interface FormLookups {
  ACCESS_TIERS: AccessTierOption[]
  AVAILABLE_FEATURES: FeatureOption[]
}

export type { AccessTierOption, FeatureOption }

export function useFormLookups(): FormLookups {
  const { t } = useTranslation('admin')
  return {
    ACCESS_TIERS: [
      { value: 'basic', label: t('licensing.tiers.basic') },
      { value: 'professional', label: t('licensing.tiers.professional') },
      { value: 'enterprise', label: t('licensing.tiers.enterprise') },
    ],
    AVAILABLE_FEATURES: [
      {
        value: 'basic_analysis',
        label: t('licensing.features.basicAnalysis.label'),
        description: t('licensing.features.basicAnalysis.description'),
      },
      {
        value: 'advanced_reporting',
        label: t('licensing.features.advancedReporting.label'),
        description: t('licensing.features.advancedReporting.description'),
      },
      {
        value: 'api_access',
        label: t('licensing.features.apiAccess.label'),
        description: t('licensing.features.apiAccess.description'),
      },
      {
        value: 'ai_analysis',
        label: t('licensing.features.aiAnalysis.label'),
        description: t('licensing.features.aiAnalysis.description'),
      },
      {
        value: 'priority_support',
        label: t('licensing.features.prioritySupport.label'),
        description: t('licensing.features.prioritySupport.description'),
      },
      {
        value: 'unlimited_cases',
        label: t('licensing.features.unlimitedCases.label'),
        description: t('licensing.features.unlimitedCases.description'),
      },
      {
        value: 'unlimited_storage',
        label: t('licensing.features.unlimitedStorage.label'),
        description: t('licensing.features.unlimitedStorage.description'),
      },
      {
        value: 'all_features',
        label: t('licensing.features.allFeatures.label'),
        description: t('licensing.features.allFeatures.description'),
      },
    ],
  }
}
